import { render, staticRenderFns } from "./UPXXYVVV.vue?vue&type=template&id=7789f502&scoped=true"
import script from "./UPXXYVVV.vue?vue&type=script&lang=js"
export * from "./UPXXYVVV.vue?vue&type=script&lang=js"
import style0 from "./UPXXYVVV.vue?vue&type=style&index=0&id=7789f502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789f502",
  null
  
)

export default component.exports